import client from './client';

export const register = (data: { email: string; password: string; name: string; phone?: string }) =>
  client.post('/auth/register', data);

export const login = (data: { email: string; password: string }) =>
  client.post('/auth/login', data);

export const getMe = () => client.get('/auth/me');
